import { useSnack } from 'enova-frontend-components';
import { useTranslation } from 'react-i18next';
import { useMutation, useQueryClient } from 'react-query';
import { useParams } from 'react-router-dom';

import { Malform, SoknadSteg } from '../../../../components/registering/utils/registerEnums';
import * as api from '../../../../services/api';
import { RegistrationRequest } from '../../../../types/building';
import { createErrorMessage } from '../../../../utils/utils';
import { Energimerkeversjon } from '../../../../types/energimerke';
import { OmBoligenFormData } from '../../pages/omBoligen/form/types';
import useStore from '../../../../hooks/useStore';
import { formDataToUserInput } from '../../pages/omBoligen/form/utils/dataMapper';
import { queryKeys } from '../../../../utils/react-query';

interface CreateRegistrationInput {
  formData: OmBoligenFormData;
  soknadSteg?: SoknadSteg;
  soknadId?: string;
}

// TODO: Create an empty registration before entering the form, so that we have a registrationId to work with.
// The API currently requires data to be sent when creating a registration
export const useCreateV2025Registration = () => {
  const { addSnack } = useSnack();
  const { t } = useTranslation();
  const queryClient = useQueryClient();
  const { buildingId } = useParams();
  const store = useStore();
  const userInput = store.getState().register.userInput;

  const { mutate, isLoading } = useMutation(
    ({ formData, soknadSteg, soknadId }: CreateRegistrationInput) => {
      const newRegistration: RegistrationRequest = {
        bruksAreal: formData.bygginfo?.area,
        byggAr: formData.bygginfo?.year,
        byggType: formData.bygginfo?.byggtype,
        energiObjektId: buildingId,
        energiObjektType: '',
        malform: Malform.Bokmal,
        oppvarmetBruksAreal: formData.bygginfo?.heatedArea,
        userInput: formDataToUserInput(formData, userInput),
        properties: {
          energimerkeVersjon: Energimerkeversjon.V2025
        },
        soknadSteg,
        soknadId
      };

      return api.createRegistration(newRegistration);
    },
    {
      onSuccess: () => {
        // Update all building queries. Dont know why this is important
        queryClient.invalidateQueries([queryKeys.building, buildingId]);
        queryClient.invalidateQueries([queryKeys.energyAnalysisList, buildingId]);
      },
      onError: () => {
        addSnack(createErrorMessage(t('registerScreen.saveRegistration.saveFailed')), { variant: 'error' });
      }
    }
  );

  return { createRegistration: mutate, createIsLoading: isLoading };
};
